import { OffCanvasChildComponent } from 'src/app/model/off-canvas-child-component';
import { OffCanvasService } from 'src/app/services';
import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    templateUrl: './info-credit-card-info.component.html',
    styleUrls: ['./info-credit-card-info.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class InfoCreditCardInfoComponent extends OffCanvasChildComponent
{
    public constructor(offCanvasService: OffCanvasService)
    {
        super(offCanvasService);
    }
}
